module.exports = __webpack_public_path__ + "static/media/img-web-resa.04b8ca1c.png";